import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { loadPdtCate } from '@app/actions/shoppingmall/pdt-cate.action';
import { clearWAlert, setWAlert } from '@app/actions/w-alert.action';
import { MessageConstant } from '@app/common/constant/message.constant';
import { MyProgramConstant } from '@app/common/constant/my-program.constant';
import { WAlertConstant } from '@app/common/constant/w-alert-icon.constant';
import { AuthUtil } from '@app/common/util/auth.util';
import { ValidationUtil } from '@app/common/util/validation.util';
import { WAlertStatus } from '@app/models/components/w-alert-stauts.model';
import { PdtCateModel } from '@app/models/shoppingmall/pdt-cate.model';
import { SmWownetModel } from '@app/models/system/sm-wownet.model';
import { getPdtCates, PdtCateState } from '@app/selectors/shoppingmall/pdt-cate.selector';
import { getSmWownet, SmWownetState } from '@app/selectors/system/sm-wownet.selector';
import { getWAlertStatus, WAlertState } from '@app/selectors/w-alert.selector';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';




@Component({
  selector: 'hp-products',
  templateUrl: './hp-products.component.html',
  styleUrls: ['./hp-products.component.css']
})
export class HpProductsComponent implements OnInit {
  @Input() urlWownet : String = "";

  pdtCates$ = new Observable<PdtCateModel[]>;
  contentsPdtCates : any = "";

  smWownet$ = new Observable<SmWownetModel>();
  smWownet: any = {} as SmWownetModel;

  isLogined: boolean = AuthUtil.isLogined();
  wAlertStatus$ = new Observable<WAlertStatus>();

  actionConfirmLogined: string = "action_confirm_logined";

  constructor(private _pdtCateStore: Store<PdtCateState>,   private _router: Router,
    private _smWownetStateStore: Store<SmWownetState>,
    private _wAlertStore: Store<WAlertState>,) {
    this.smWownet$ = this._smWownetStateStore.select(getSmWownet);
    this.pdtCates$ = this._pdtCateStore.select(getPdtCates);
    this.wAlertStatus$ = this._wAlertStore.select(getWAlertStatus);
  }

  ngOnInit(): void {
    this.loadDataPdtCate();

    this.smWownet$.subscribe(res => {
      this.smWownet = res;
    });

    this.wAlertStatus$.subscribe(res => this.handleActionConfirm(res));

  }

  loadDataPdtCate() :void {
    this._pdtCateStore.dispatch(loadPdtCate({ key: "" }));
    this.pdtCates$.subscribe(res => {
      if (ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.contentsPdtCates = res.filter(x => x.lv == "1");
      }
    });
  }

  goToShoppingMall(item : any) {
    this._router.navigateByUrl(MyProgramConstant.urlShopping + `?cate=${item.cateCd}`);
  }

  handleOnClickProductDetail(item: any): void {
    if (ValidationUtil.isNotNullAndNotEmpty(item)) {
      if (this.smWownet.lshowPdtYn !== "Y" && !this.isLogined) {
        this.showAlertRequiredLogined();
      } else {
        this._router.navigate([MyProgramConstant.urlShopping + `/product/${item}`]);
      }
    }
  }

  showAlertRequiredLogined(): void {
    this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.confirm, message: MessageConstant.msgRequiredLogin, action: this.actionConfirmLogined } }));
  }

  handleActionConfirm(status: WAlertStatus): void {
    if (status.action === this.actionConfirmLogined && status.isConfirm) {
      this._wAlertStore.dispatch(clearWAlert());
      this._router.navigate(["/login"]);
    }
  }
}
